import {HTMLProps} from 'react';
import clsx from 'clsx';

type Props = HTMLProps<HTMLHeadingElement> & {
  ['data-testid']?: string;
};

const SectionSubtitle = ({className, children, ...props}: Props) => {
  return (
    <h3 className={clsx('my-4 text-2xl font-semibold tracking-tight text-violet', className)} {...props}>
      {children}
    </h3>
  );
};

export default SectionSubtitle;
